import React from 'react'
import {Route, IndexRoute} from 'react-router'

import AnalyticsView from 'views/AnalyticsView'
import AnalyticsViewMenu from 'views/AnalyticsView/Menu'
import ReportsView from 'views/ReportsView'
import ReportView, {ReportViewMenu} from 'views/ReportView'
import {getReport} from 'redux/modules/reports/selectors'
import OnboardingWizard from 'components/OnboardingWizard'
import {StepTypes} from 'redux/modules/onboard/steps'

const withOnboardingWizard = (Component, currentStep) => {
  return props => (
    <>
      <OnboardingWizard currentStep={currentStep} />
      <Component {...props} />
    </>
  )
}

export default (store, trackRoute) => {
  return (
    <Route path='analytics' title='Analytics Explorer'>
      <Route path='reports' title='Reports'>
        <IndexRoute
          components={{main: ReportsView, menu: AnalyticsViewMenu}}
          onEnter={trackRoute('reports')}
        />
        <Route
          path=':reportId'
          components={{main: ReportView, menu: ReportViewMenu}}
          title={({reportId}) => {
            const report = getReport(store.getState(), reportId)

            return report ? report.name : '...'
          }}
          withBreadcrumbs
          disableDatePicker
          onEnter={trackRoute('report')}
        />
      </Route>
      <IndexRoute
        title='Analytics Explorer'
        components={{menu: AnalyticsViewMenu, main: withOnboardingWizard(AnalyticsView, StepTypes.ANALYTICS_EXPLORER)}}
        onEnter={trackRoute('analytics-explorer')}
        showReportButton
      />
    </Route>
  )
}



// WEBPACK FOOTER //
// ./client/routes/analyticsExplorer.js